export const colors = {
  lco: {
    primary: {
      main: "#9C27B0",
      hover: "rgba(156, 39, 176, 0.04)",
      selected: "rgba(156, 39, 176, 0.08)",
      focusVisible: "rgba(156, 39, 176, 0.3)",
      outlinedBorder: "rgba(156, 39, 176, 0.5)",
      ContrastText: "#FFFFFF",
    },
    secondary: {
      main: "#391B41",
    },
    neutral: {
      main: "#E0E0E0",
    },
    white: "#FFFFFF",
    textHeading: "#000000",
    link: "#1565C0",
    divider:"rgba(0, 0, 0, 0.12)",
    error: {
      backGround: "#FDEDED",
      color: "#5F2120",
      main: "#D32F2F",
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "#000000",
      secondary: "#000000",
      disabled: "#00000061",
      hint: "#00000061",
    },
    warning: {
      main: "#EF6C00",
      light: "#FF9800",
      dark: "#E65100",
      contrastText: "#000000de",
    },
    success: {
      main: "#2E7D32",
      light: "#4CAF50",
      dark: "#1B5E20",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#EEEEEE",
      paper: "#fff",
    },
  },
  light: {
    primary: {
      main: "#92278F",
      light: "#92278F",
      dark: "#92278F",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#E0E0E0",
      light: "#DBDBDB",
      dark: "#939393",
      contrastText: "#000000de",
    },
    text: {
      primary: "#000000",
      secondary: "#000000",
      disabled: "#00000061",
      hint: "#00000061",
    },
    input: {
      label: "#ff0000", // Red color for labels
      text: "#ff0000", // Red color for input text
      placeholder: "#ff0000", // Red color for placeholder text
      border: "#ff0000", // Red color for input border
    },
    background: {
      default: "#FAFAFA",
      paper: "#fff",
    },
    error: {
      main: "#f44336",
      light: "#E57373",
      dark: "#D32F2F",
      contrastText: "#fff",
    },
    success: {
      main: "#4CAF50",
      light: "#81C784",
      dark: "#388E3C",
      contrastText: "#000000de",
    },
    warning: {
      main: "#FF9800",
      light: "#FFB74D",
      dark: "#BF5000",
      contrastText: "#000000de",
    },
    divider: "#E0E0E0",
  },
  dark: {
    primary: {
      main: "#90CAF9",
      light: "#3393DC",
      dark: "#005494",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#D2D2D2",
      light: "#DBDBDB",
      dark: "#939393",
      contrastText: "#000000de",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#ffffffcc",
      disabled: "#ffffffc9",
      hint: "#ffffffc9",
    },
    background: {
      default: "#303030",
      paper: "#424242",
    },
    error: {
      main: "#f44336",
      light: "#E57373",
      dark: "#D32F2F",
      contrastText: "#fff",
    },
    success: {
      main: "#4CAF50",
      light: "#81C784",
      dark: "#388E3C",
      contrastText: "#000000de",
    },
    warning: {
      main: "#FF9800",
      light: "#FFB74D",
      dark: "#BF5000",
      contrastText: "#000000de",
    },
    divider: "#ffffff1f",
  },
  headings: {
    h1: {
      fontSize: "24px",
      fontWeight: 400,
      lineHeight: "133.4%",
    },
    h2: {
      fontSize: "18px",
      fontWeight: 500,
    },
    h3: {
      fontSize: "14px",
      fontWeight: 400,
    },
  },
};
export default colors;
